import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const externalApi = "External API";
const endpointId = "endpointId";
const endpointName = "endpointName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callExternalApi,
  category: NodeTypeCategory.services,
  label: externalApi,
  setting: "processFlowsExternalApiUse",
  size: NodeSize.Small,
  controlInputs: [{ name: "call"}],
  controlOutputs: [{ name: "completed" }],
  dataInputs: [],
  documentDataInputListName: "inputs",
  dataOutputs: [],
  documentDataOutputList: "results",
  nodeConfigProperties: [
    {
      name: endpointId,
      label: "Endpoint",
      propertyType: NodeConfigPropertyType.ExternalApiEndpoint,
      schemaSourceSystemType: DocumentSchemaSource.externalApi,
      schemaSystem: { createIo: true }
    },
    {
      name: endpointName,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "inputs",
      sectionName: "Input",
      propertyType: NodeConfigPropertyType.EnabledInputs
    },
    {
      name: "results",
      sectionName: "results",
      propertyType: NodeConfigPropertyType.EnabledOutputs
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallExternalApiNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = data.nodeProperties[endpointName] ?? externalApi;
  data.nodeProperties.label = label;
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
